import "./cadastro-participantes-vila-pinto.b081ef1c.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dCqD9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");

var $hPtJY = parcelRequire("hPtJY");
window.Buffer = (0, $6ZWSX.Buffer);
window.process = (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY)));

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("jOBGJ", function(module, exports) {
module.exports = import("u8cgP").then(()=>parcelRequire('bhHFP'));

});

parcelRegister("3m8wz", function(module, exports) {
module.exports = import("9FoKk").then(()=>parcelRequire('dbOS5'));

});

parcelRegister("bvPsb", function(module, exports) {
module.exports = import("d0Zl7").then(()=>parcelRequire('hEplm'));

});

parcelRequire("dCqD9");

var $6AR8M = parcelRequire("6AR8M");

var $ilpIi = parcelRequire("ilpIi");
document.documentElement.classList.add("js-ready");
let $dddf3c342e27f73e$var$auth = null;
let $dddf3c342e27f73e$var$db = null;
let $dddf3c342e27f73e$var$selectedCoop = null;



const $dddf3c342e27f73e$var$COOPS = {
    "vila-pinto": {
        label: "Vila Pinto",
        init: ()=>(parcelRequire("jOBGJ")),
        redirect: "./cooperativa-vila-pinto.html"
    },
    "cooadesc": {
        label: "COOADESC",
        init: ()=>(parcelRequire("3m8wz")),
        redirect: "./cooperativa-cooadesc.html"
    },
    "padre-cacique": {
        label: "Padre Cacique",
        init: ()=>(parcelRequire("bvPsb")),
        redirect: "./cooperativa-padre-cacique.html"
    }
};
const $dddf3c342e27f73e$var$coopSelector = document.getElementById("coopSelector");
const $dddf3c342e27f73e$var$loginCard = document.getElementById("loginCard");
const $dddf3c342e27f73e$var$backToCoops = document.getElementById("backToCoops");
const $dddf3c342e27f73e$var$loginForm = document.getElementById("loginForm");
const $dddf3c342e27f73e$var$loginBtn = document.getElementById("loginBtn");
const $dddf3c342e27f73e$var$loginEmail = document.getElementById("loginEmail");
const $dddf3c342e27f73e$var$loginPassword = document.getElementById("loginPassword");
const $dddf3c342e27f73e$var$rememberMe = document.getElementById("rememberMe");
const $dddf3c342e27f73e$var$msgBox = document.getElementById("msgBox");
const $dddf3c342e27f73e$var$loadingbar = document.getElementById("loadingbar");
const $dddf3c342e27f73e$var$resetPwdLink = document.getElementById("resetPwdLink");
const $dddf3c342e27f73e$var$cardTitle = document.getElementById("cardTitle");
const $dddf3c342e27f73e$var$cardSubtitle = document.getElementById("cardSubtitle");
function $dddf3c342e27f73e$var$showMsg(type, text) {
    if (!$dddf3c342e27f73e$var$msgBox) return;
    $dddf3c342e27f73e$var$msgBox.classList.remove("is-error", "is-success");
    $dddf3c342e27f73e$var$msgBox.classList.add(type === "error" ? "is-error" : "is-success");
    $dddf3c342e27f73e$var$msgBox.textContent = text;
}
function $dddf3c342e27f73e$var$clearMsg() {
    if (!$dddf3c342e27f73e$var$msgBox) return;
    $dddf3c342e27f73e$var$msgBox.classList.remove("is-error", "is-success");
    $dddf3c342e27f73e$var$msgBox.textContent = "";
}
function $dddf3c342e27f73e$var$setLoading(state) {
    if ($dddf3c342e27f73e$var$loginBtn) {
        $dddf3c342e27f73e$var$loginBtn.disabled = state;
        $dddf3c342e27f73e$var$loginBtn.textContent = state ? "Entrando..." : "Entrar";
    }
    $dddf3c342e27f73e$var$loadingbar?.classList.toggle("show", state);
}
function $dddf3c342e27f73e$var$normalizeEmail(value) {
    return String(value || "").trim().toLowerCase();
}
function $dddf3c342e27f73e$var$normalizeTerritory(value) {
    return String(value || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll("_", "-").replace(/\s+/g, "-");
}
function $dddf3c342e27f73e$var$isActiveProfile(profile) {
    return profile?.status === "active" || profile?.status === "aprovado" || profile?.active === true || profile?.ativo === true;
}
async function $dddf3c342e27f73e$var$getUserProfile(uid) {
    if (!$dddf3c342e27f73e$var$db) return null;
    const snap = await (0, $ilpIi.getDoc)((0, $ilpIi.doc)($dddf3c342e27f73e$var$db, "users", uid));
    if (!snap.exists()) return null;
    return {
        id: snap.id,
        ...snap.data()
    };
}
function $dddf3c342e27f73e$var$getRedirect(profile) {
    const role = String(profile?.role || profile?.perfil || "").toLowerCase();
    if (role === "governanca" || role === "gestor" || role === "superadmin" || role === "admin_master") return "./governanca.html";
    const territory = $dddf3c342e27f73e$var$normalizeTerritory(profile?.territoryId || profile?.cooperativaId || profile?.cooperativeId || $dddf3c342e27f73e$var$selectedCoop);
    if (territory === "vila-pinto") return "./cooperativa-vila-pinto.html";
    if (territory === "cooadesc" || territory === "coadesc") return "./cooperativa-cooadesc.html";
    if (territory === "padre-cacique" || territory === "padrecacique") return "./cooperativa-padre-cacique.html";
    return $dddf3c342e27f73e$var$COOPS[$dddf3c342e27f73e$var$selectedCoop]?.redirect || "./login.html";
}
async function $dddf3c342e27f73e$var$selectCoop(coopKey) {
    const coop = $dddf3c342e27f73e$var$COOPS[coopKey];
    if (!coop) {
        $dddf3c342e27f73e$var$showMsg("error", "Cooperativa inv\xe1lida.");
        return;
    }
    try {
        $dddf3c342e27f73e$var$clearMsg();
        $dddf3c342e27f73e$var$selectedCoop = coopKey;
        const module = await coop.init();
        $dddf3c342e27f73e$var$auth = module.auth;
        $dddf3c342e27f73e$var$db = module.db;
        if (!$dddf3c342e27f73e$var$auth || !$dddf3c342e27f73e$var$db) throw new Error("Firebase n\xe3o retornou auth/db.");
        if ($dddf3c342e27f73e$var$cardTitle) $dddf3c342e27f73e$var$cardTitle.textContent = `Entrar \u{2022} ${coop.label}`;
        if ($dddf3c342e27f73e$var$cardSubtitle) $dddf3c342e27f73e$var$cardSubtitle.textContent = `Use seu e-mail autorizado para acessar o painel da ${coop.label}.`;
        $dddf3c342e27f73e$var$coopSelector.style.display = "none";
        $dddf3c342e27f73e$var$loginCard.style.display = "block";
        (0, $6AR8M.onAuthStateChanged)($dddf3c342e27f73e$var$auth, async (user)=>{
            if (!user) return;
            try {
                const profile = await $dddf3c342e27f73e$var$getUserProfile(user.uid);
                if (!profile || !$dddf3c342e27f73e$var$isActiveProfile(profile)) return;
                $dddf3c342e27f73e$var$showMsg("success", `Sess\xe3o ativa encontrada em ${coop.label}. Entrando...`);
                setTimeout(()=>{
                    window.location.href = $dddf3c342e27f73e$var$getRedirect(profile);
                }, 700);
            } catch (error) {
                console.error("Erro ao verificar sess\xe3o:", error);
            }
        });
    } catch (error) {
        console.error("Erro ao carregar Firebase:", error);
        $dddf3c342e27f73e$var$auth = null;
        $dddf3c342e27f73e$var$db = null;
        $dddf3c342e27f73e$var$selectedCoop = null;
        $dddf3c342e27f73e$var$showMsg("error", "N\xe3o foi poss\xedvel carregar o Firebase desta cooperativa. Confira o nome do firebase-init.");
    }
}
document.querySelectorAll("[data-coop]").forEach((button)=>{
    button.addEventListener("click", ()=>{
        $dddf3c342e27f73e$var$selectCoop(button.dataset.coop);
    });
});
$dddf3c342e27f73e$var$backToCoops?.addEventListener("click", async ()=>{
    try {
        if ($dddf3c342e27f73e$var$auth?.currentUser) await (0, $6AR8M.signOut)($dddf3c342e27f73e$var$auth);
    } catch (_) {}
    $dddf3c342e27f73e$var$auth = null;
    $dddf3c342e27f73e$var$db = null;
    $dddf3c342e27f73e$var$selectedCoop = null;
    $dddf3c342e27f73e$var$clearMsg();
    $dddf3c342e27f73e$var$loginCard.style.display = "none";
    $dddf3c342e27f73e$var$coopSelector.style.display = "block";
    if ($dddf3c342e27f73e$var$loginEmail) $dddf3c342e27f73e$var$loginEmail.value = "";
    if ($dddf3c342e27f73e$var$loginPassword) $dddf3c342e27f73e$var$loginPassword.value = "";
});
$dddf3c342e27f73e$var$loginForm?.addEventListener("submit", async (event)=>{
    event.preventDefault();
    $dddf3c342e27f73e$var$clearMsg();
    if (!$dddf3c342e27f73e$var$auth || !$dddf3c342e27f73e$var$db || !$dddf3c342e27f73e$var$selectedCoop) {
        $dddf3c342e27f73e$var$showMsg("error", "Selecione uma cooperativa primeiro.");
        return;
    }
    const email = $dddf3c342e27f73e$var$normalizeEmail($dddf3c342e27f73e$var$loginEmail?.value);
    const password = $dddf3c342e27f73e$var$loginPassword?.value || "";
    if (!email || !password) {
        $dddf3c342e27f73e$var$showMsg("error", "Informe e-mail e senha.");
        return;
    }
    try {
        $dddf3c342e27f73e$var$setLoading(true);
        await (0, $6AR8M.setPersistence)($dddf3c342e27f73e$var$auth, $dddf3c342e27f73e$var$rememberMe?.checked ? (0, $6AR8M.browserLocalPersistence) : (0, $6AR8M.browserSessionPersistence));
        const credential = await (0, $6AR8M.signInWithEmailAndPassword)($dddf3c342e27f73e$var$auth, email, password);
        const profile = await $dddf3c342e27f73e$var$getUserProfile(credential.user.uid);
        if (!profile) {
            await (0, $6AR8M.signOut)($dddf3c342e27f73e$var$auth);
            $dddf3c342e27f73e$var$showMsg("error", "Login feito, mas este usu\xe1rio n\xe3o possui cadastro na cole\xe7\xe3o users deste Firebase.");
            return;
        }
        if (!$dddf3c342e27f73e$var$isActiveProfile(profile)) {
            await (0, $6AR8M.signOut)($dddf3c342e27f73e$var$auth);
            $dddf3c342e27f73e$var$showMsg("error", "Usu\xe1rio sem acesso ativo.");
            return;
        }
        window.location.href = $dddf3c342e27f73e$var$getRedirect(profile);
    } catch (error) {
        console.error("Erro no login:", error);
        const code = error?.code || "";
        let text = "N\xe3o foi poss\xedvel entrar.";
        if (code.includes("invalid-credential")) text = "E-mail ou senha inv\xe1lidos.";
        else if (code.includes("wrong-password")) text = "Senha incorreta.";
        else if (code.includes("user-not-found")) text = "Usu\xe1rio n\xe3o encontrado neste Firebase.";
        else if (code.includes("network-request-failed")) text = "Falha de rede.";
        else if (code.includes("permission-denied")) text = "Sem permiss\xe3o para ler o perfil em users.";
        $dddf3c342e27f73e$var$showMsg("error", text);
    } finally{
        $dddf3c342e27f73e$var$setLoading(false);
    }
});
$dddf3c342e27f73e$var$resetPwdLink?.addEventListener("click", async (event)=>{
    event.preventDefault();
    $dddf3c342e27f73e$var$clearMsg();
    if (!$dddf3c342e27f73e$var$auth || !$dddf3c342e27f73e$var$selectedCoop) {
        $dddf3c342e27f73e$var$showMsg("error", "Selecione uma cooperativa primeiro.");
        return;
    }
    const email = $dddf3c342e27f73e$var$normalizeEmail($dddf3c342e27f73e$var$loginEmail?.value);
    if (!email) {
        $dddf3c342e27f73e$var$showMsg("error", "Digite seu e-mail para recuperar a senha.");
        return;
    }
    try {
        await (0, $6AR8M.sendPasswordResetEmail)($dddf3c342e27f73e$var$auth, email);
        $dddf3c342e27f73e$var$showMsg("success", "Enviamos o link de recupera\xe7\xe3o para seu e-mail.");
    } catch (error) {
        console.error("Erro reset senha:", error);
        $dddf3c342e27f73e$var$showMsg("error", "N\xe3o foi poss\xedvel enviar o e-mail de recupera\xe7\xe3o.");
    }
});


//# sourceMappingURL=login.4b8d2ca3.js.map
